module.exports = __webpack_public_path__ + "img/icon-8.b47bfb39.png";